import React, { useState } from 'react';

import { useTheme } from 'styled-components';
import { useHistory } from 'react-router-dom';

import { AiFillPlusCircle } from 'react-icons/ai';
import { AiOutlineCloseSquare } from 'react-icons/ai';
import { BiSearch } from 'react-icons/bi';
import { TiArrowBack } from 'react-icons/ti';
import { IoMdRefresh } from 'react-icons/io';
import { FaFilter } from 'react-icons/fa';
// import { IoMdChatboxes } from 'react-icons/io';
// import { IoMdClose } from 'react-icons/io';

import Notifications from './Notifications';

// import { useIAmode } from '~/hooks/iamode';

import {
  Container,
  Content,
  Title,
  Right,
  Search,
  PlusBtn,
  FilterBtn,
  // IaBtn,
  RefreshBtn,
} from './styles';

import { HeaderProps } from './interface';

const Header: React.FC<HeaderProps> = ({
  title,
  plus,
  plusLabel,
  subtitle,
  onSearch,
  isSearch,
  placeholder,
  back,
  icon,
  isRefresh,
  onRefresh,
  isFilters,
  toggleFilters,
}) => {
  const { colors } = useTheme();

  // const { enable, toggleIAmode } = useIAmode();

  const history = useHistory();

  const [searchStr, setSearchStr] = useState('');

  const searching = () => {
    if (onSearch) {
      onSearch(searchStr);
    }
  };

  const clearSearching = () => {
    setSearchStr('');
    if (onSearch) {
      onSearch('');
    }
  };

  const onPlus = (pPage: string) => {
    history.push(`/${pPage}/0`);
  };

  const onBack = () => {
    if (back) {
      history.goBack();
    }
  };

  return (
    <>
      <Notifications />
      <Container>
        <Content>
          <Title>
            {icon ? <i>{icon}</i> : null}

            {back ? (
              <button onClick={onBack}>
                <TiArrowBack size={26} color={colors.IC1} />
              </button>
            ) : null}

            <div>
              {title ? <h1>{title}</h1> : null}
              {subtitle ? <h2>{subtitle}</h2> : null}
            </div>
          </Title>

          <Right className={isSearch ? 'search-enable' : 'search-disable'}>
            {isSearch ? (
              <Search>
                <input
                  type="text"
                  placeholder={placeholder}
                  value={searchStr}
                  onChange={e => setSearchStr(e.target.value)}
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      searching();
                    }
                  }}
                />
                {searchStr ? (
                  <button
                    type="button"
                    onClick={clearSearching}
                    className="close"
                  >
                    <AiOutlineCloseSquare size={18} color={colors.IC1} />
                  </button>
                ) : null}
                <button type="button" onClick={searching} className="search">
                  <BiSearch size={22} color={colors.IC1} />
                </button>
              </Search>
            ) : null}

            <main>
              {isFilters ? (
                <FilterBtn onClick={toggleFilters}>
                  <FaFilter size={22} color={colors.IC1} />
                  <span>FILTROS</span>
                </FilterBtn>
              ) : null}

              {/* {!enable ? (
                <IaBtn onClick={toggleIAmode}>
                  {enable ? (
                    <IoMdClose size={26} color={colors.IC1} />
                  ) : (
                    <IoMdChatboxes size={26} color={colors.IC1} />
                  )}
                  <div>
                    <span>CHAT GESTOR</span>
                    <small>IA</small>
                  </div>
                  <ins>Beta</ins>
                </IaBtn>
              ) : null} */}

              {plus ? (
                <PlusBtn onClick={() => onPlus(plus)}>
                  <AiFillPlusCircle size={22} color={colors.IC1} />
                  <span>{plusLabel ? plusLabel : ''}</span>
                </PlusBtn>
              ) : null}

              {isRefresh ? (
                <RefreshBtn onClick={onRefresh} title="Recarregar dados...">
                  <IoMdRefresh size={26} color={colors.IC1} />
                </RefreshBtn>
              ) : null}
            </main>
          </Right>
        </Content>
      </Container>
    </>
  );
};

export default Header;
